export default "__VITE_ASSET__XGNdWY9b__"